export default {
  header: {
    title: 'Recompense',
  },
  content: {
    title: 'Ai {{balance}} puncte',
    description:
      'Cheltuiește {{amount}}, obții {{rewards}} puncte! Adaugă articole gratuite în coș cu punctele câștigate.',
    articles: {
      title: 'Câștigă puncte la fiecare comandă',
      spend_description: 'Fiecare {{amount}} cheltuiți adaugă {{rewards}} puncte în contul tău.',
      redeem_title: 'Valorifică-ți punctele',
      redeem_description:
        'Schimbă punctele pentru recompense gratuite! Începe să câștigi recompense de la {{minSpendingLimit}} puncte, echivalent cu {{amount}} cheltuiți',
      discounts_title: 'Descoperă avantaje exclusive',
      discounts_description: 'Deblochează oferte, reduceri și promoții exclusive.',
    },
  },
};
